import { useDrag } from 'react-dnd';

interface DragItemProps {
  readonly children: React.ReactNode;
  readonly text: string;
  readonly type: string;
}

const DragItem = ({ children, text, type }: DragItemProps) => {
  const [collected, dragRef] = useDrag(
    () => ({
      type,
      item: { text },
      collect: (monitor) => ({
        opacity: monitor.isDragging() ? 0.5 : 1,
        isDragging: monitor.isDragging(),
      }),
    }),
    [],
  );

  return (
    <div ref={dragRef} style={{ opacity: collected.opacity }}>
      {children}
    </div>
  );
};

export default DragItem;
